// Hook: centralise la lecture des infos d'offre depuis l'URL
// et dérive les URLs utiles (offre publique, formulaire ATS).
// Utilisation: const { offerId, offerTitle, offerUrl, formUrl } = useOffer();
import { useMemo } from 'react';
import { getQueryParam } from '../utils/get-query-params';
import { buildAtsFormUrl, buildOfferUrl, resolveLogoUrl } from '../utils/urls';

export type OfferPrefill = {
  role: string;
  schoolLevel: string;
  languageCode: string;
  experienceMonths: string;
  availableDate: string;
  contractType: string;
  workType: string[];
  city: string;
  minSalary: string;
  maxSalary: string;
  currency: string;
  companyLogoUrl: string;
};

const normalizeWorkType = (value: string) => (value === 'none' ? 'non' : value);

export function useOffer() {
  const offerId = useMemo(() => getQueryParam('jobId') || getQueryParam('opportunity_id'), []);
  const offerTitle = useMemo(() => getQueryParam('title'), []);
  const offerPrefill = useMemo<OfferPrefill>(() => ({
    role: getQueryParam('role') || getQueryParam('title') || '',
    schoolLevel: getQueryParam('schoolLevel') || getQueryParam('degree') || '',
    languageCode: getQueryParam('languageCode') || getQueryParam('language') || '',
    experienceMonths: getQueryParam('experienceMonths') || getQueryParam('months_of_experience') || '',
    availableDate: getQueryParam('availableDate') || 'NOW',
    contractType: getQueryParam('contractType') || getQueryParam('type_of_opportunity') || '',
    workType: (getQueryParam('workType') || getQueryParam('remoteWork') || getQueryParam('remote_work') || '')
      .split(',')
      .map((value) => value.trim())
      .map(normalizeWorkType)
      .filter(Boolean),
    city: getQueryParam('city') || '',
    minSalary: getQueryParam('minSalary') || getQueryParam('salary_min') || '',
    maxSalary: getQueryParam('maxSalary') || getQueryParam('salary_max') || '',
    currency: getQueryParam('currency') || 'EUR',
    companyLogoUrl: resolveLogoUrl(
      getQueryParam('companyLogo') ||
        getQueryParam('company_logo') ||
        getQueryParam('companyLogoUrl') ||
        getQueryParam('company_logo_url') ||
        getQueryParam('logoUrl') ||
        getQueryParam('logo'),
    ) || '',
  }), []);

  const offerUrl = useMemo(() => buildOfferUrl(offerId), [offerId]);
  const formUrl = useMemo(() => buildAtsFormUrl(offerId), [offerId]);

  return { offerId, offerTitle, offerUrl, formUrl, offerPrefill, companyLogoUrl: offerPrefill.companyLogoUrl };
}
